import React from 'react';
import { LoginCallback } from '@okta/okta-react';
import FullScreenLoader from 'src/components/FullScreenLoader';

function AuthCallback() {
  return <LoginCallback loadingElement={<FullScreenLoader />} />;
}

export default AuthCallback;
